module.exports = __webpack_public_path__ + "res/32-img_play_bg.7f05051436179cf050f6ee59ee0dc20b.png";